var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"ma-2",attrs:{"dense":"","outlined":"","color":"gray","type":"error"}},[_vm._v(" Plazas Agotadas ")])}
var staticRenderFns = []

export { render, staticRenderFns }